/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Directive, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';

/**
 * Infinite scroll directive that emits events when scroll reaches the end of the host element
 */
@Directive({
  selector: '[gp-infinite-scroll]'
})
export class InfiniteScrollDirective {

  @Output()
  public infiniteReached: EventEmitter<any> = new EventEmitter();

  @Input()
  public distance: number = 40;

  @Input()
  public enabled: boolean = true;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  public ngOnInit() {
    this.renderer.listen(this.elementRef.nativeElement, 'scroll', this.onScroll.bind(this));
  }

  public onScroll() {
    if (!this.enabled) {
      return;
    }
    const isInfinite =
      this.elementRef.nativeElement.scrollTop >=
      this.elementRef.nativeElement.scrollHeight - this.elementRef.nativeElement.clientHeight - this.distance;

    if (isInfinite) {
      this.infiniteReached.emit(undefined);
    }
  }
}
